import React from 'react';

const SYMBOLS = ['$', '€', '£', '¥', '₿', '₹'];

export default function Ticker() {
  const row = Array.from({ length: 24 }, (_, i) => SYMBOLS[i % SYMBOLS.length]);
  return (
    <div className="border-y border-cyan-500/10 bg-black/40 overflow-hidden">
      <div className="flex whitespace-nowrap py-2 animate-ticker gap-8">
        {[...row, ...row].map((s, i) => (
          <span key={i} className="font-mono text-cyan-300/60 text-lg tracking-wider select-none">{s}</span>
        ))}
      </div>
    </div>
  );
}
